import { render } from "./Home.vue?vue&type=template&id=e4b36c0a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=e4b36c0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e4b36c0a"

export default script